import { app } from '../../../../../../app';
import { Controller } from './ou-imported.controller';

app.component('companyDirectoryIntegrationManageConnectionOuImported', {
    bindings: {domains: '<'},
    controller: Controller,
    templateUrl: require('./ou-imported.html'),
});



// WEBPACK FOOTER //
// ./src/portal/states/company/directory-integration/manage/connection/ou-imported/ou-imported.component.js